<template>
    <div>
        <v-container grid-list-xs>
            <v-sheet class="pa-5" elevation="3">
                <Form>
                    <PageHeader>
                        <template #header>
                            <h4 class="mb-4">{{ $t("prequalify.terms") }}</h4>
                        </template>
                    </PageHeader>

                    <v-row justify="center">
                        <v-col>
                            <v-container class="term-verbiage">
                                <b>Important Information About Procedures for Opening New Account</b><br />
                                To help the government fight the funding of terrorism and money laundering activities,
                                Federal law requires all financial institutions to obtain, verify, and record
                                information that identifies each person who opens an account. What this means for you:
                                When you apply for a loan, we will ask your name, street address, email address, date of
                                birth and other information which will allow us to identify you.<br /><br />

                                <div><b>State Law Notices</b></div>
                                <b>California Residents:</b> If married, you may apply for a separate account.
                                <br />
                                <b>Delaware Residents:</b> Service charges not in excess of those permitted by law will
                                be charged on the outstanding balances from month to month.<br />
                                <div class="body-1-lg">
                                    <b
                                        >Maryland Residents: Finance Charges will be imposed in amounts or at rates not
                                        in excess of those permitted by law.</b
                                    >
                                </div>
                                <b>Nevada and Oregon Residents:</b> A service charge will be computed on the outstanding
                                balance for each month (which need not be a calendar month) or other regular period
                                agreed upon. You may at any time pay the total unpaid balance.<br />
                                <b>Ohio Residents:</b> The Ohio laws against discrimination require that all creditors
                                make credit equally available to all credit-worthy customers, and that credit reporting
                                agencies maintain separate credit histories each individual upon request. The Ohio civil
                                rights commission administers compliance with this law.<br />
                                <b>Rhode Island Residents:</b> No membership or other similar fee is imposed. <br />
                                <b>Vermont Residents:</b> Lender is engaged in loan production.<br />
                                <b>Married Wisconsin Residents:</b> No provision of a marital property agreement, a
                                unilateral statement under section 766.59 or a court decree under section 766.70
                                adversely affects the interest of the creditor unless the creditor, prior to the time
                                the credit is granted, is furnished a copy of the agreement, statement or decree or has
                                actual knowledge of the adverse provision when the obligation to the creditor is
                                incurred. we are required to ask you to provide the name and address of your spouse.
                                <br /><br />
                            </v-container>
                        </v-col>
                    </v-row>
                    <v-row class="py-0">
                        <v-col class="py-0">
                            <div class="tc-container">
                                <PDFViewer v-if="pdfUrl" :pdf-url="pdfUrl" />
                            </div>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col>
                            <v-container>
                                <b>Affirmative Consent to Accept Offer:</b>
                                <br /><br />
                                By clicking "Agree & Complete Application" below, I certify that I am at least 18 years
                                of age, and that I do not presently have a petition filed under federal bankruptcy laws
                                (whether voluntary or involuntarily) and do not anticipate filing a petition. I
                                authorize The Bank of Missouri, its successors, assigns and agents (the "Lender") to
                                obtain a full credit report (a hard inquiry) from a consumer reporting agency in
                                accordance with the federal Fair Credit Reporting Act to investigate my
                                creditworthiness. I further authorize the Lender to obtain a credit report on me for any
                                lawful purpose, including any update, extension of credit, review, or collection of my
                                account, and I specifically authorize the release of such information to the Lender.
                            </v-container>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <CheckboxField id="agreement1" v-model="printedCopyCheckbox" class="check-box"
                                >{{ $t("terms.print-checkbox") }}
                            </CheckboxField>
                            <CheckboxField
                                id="agreement2"
                                v-model="termsCheckbox"
                                class="check-box"
                                :disabled="!printedCopyCheckbox"
                                >{{ $t("terms.consent-checkbox") }}
                            </CheckboxField>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <SignaturePad
                                v-model="application.signatureData"
                                class="mt-5"
                                :disabled="!printedCopyCheckbox"
                                @signature-valid="isSignatureValid"
                            />
                        </v-col>
                    </v-row>

                    <v-card-actions class="pb-12 px-0">
                        <v-row justify="space-between">
                            <v-col>
                                <BackButton class="mr-4" color="primary" rounded>
                                    {{ $t("action.back") }}
                                </BackButton>
                            </v-col>
                            <v-col class="text-right">
                                <SubmitButton
                                    class="secondary submit-button"
                                    :disabled="
                                        !termsCheckbox ||
                                        !printedCopyCheckbox ||
                                        !validSignature ||
                                        isStipulationPending
                                    "
                                    rounded
                                    @click="accept"
                                >
                                    {{ $t("action.agreeAndCompleteApplication") }}
                                </SubmitButton>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </Form>
            </v-sheet>
        </v-container>
    </div>
</template>

<script>
    import { appendWebSessionId } from "@/util/url"
    import BackButton from "@/components/button/BackButton.vue"
    import Providers from "@/model/provider/Providers"
    import { applicationState, sessionState } from "@/state"
    import ApplyMode from "@/model/apply/ApplyMode"
    import StipulationViewMixin from "@/components/stipulation/StipulationViewMixin.vue"
    import StipulationType from "@/model/flow/StipulationType"
    import { mapState } from "vuex"
    import { applyService, googleAnalyticsService, logService } from "@/service"
    import GoogleAnalyticEvents from "@/model/google/GoogleAnalyticEvents"
    import PDFViewer from "@/components/terms/PDFViewer.vue"

    export default {
        components: { PDFViewer, BackButton },
        mixins: [StipulationViewMixin],
        data() {
            return {
                url: appendWebSessionId(`/api/v1/providers/${sessionState.providerKey}/documents/agreement`),
                providerInfo: Providers[sessionState.dynamicProviderKey.providerKey],
                applyMode: applicationState.applyMode,
                termsCheckbox: false,
                printedCopyCheckbox: false,
                validSignature: false,
                pdfUrl: "",
            }
        },

        computed: {
            ...mapState("application", {
                application: state => state.data,
            }),
        },

        async created() {
            const documentResponse = await applyService.getDocuments(sessionState.providerKey, ["terms_and_conditions"])
            const url = documentResponse.documents[documentResponse.documents.length - 1]?.uri || ""
            if (!url) {
                logService.info("Unable to retrieve terms document")
                await this.$router.push(`/providers/${sessionState.providerKey}/error`)
            }
            this.pdfUrl = url
        },

        methods: {
            getStipulationType() {
                return StipulationType.PRINT_DOCUMENT
            },

            accept() {
                if (this.applyMode === ApplyMode.FULL) {
                    googleAnalyticsService.buttonEvent(
                        GoogleAnalyticEvents.FULL_APPLICATION_SUBMITTED,
                        "Fortiva Full Application Submitted"
                    )
                    this.$router.push(`/providers/${sessionState.providerKey}/fullApplicationSubmit`)
                } else {
                    this.$router.push(`/providers/${sessionState.providerKey}/acceptOfferSubmit`)
                }
            },
            isSignatureValid(validSignature) {
                this.validSignature = validSignature
            },
        },
    }
</script>

<style lang="scss">
    .v-btn {
        font-size: 16px !important;
        padding-top: 10px !important;
        padding-bottom: 10px !important;
    }

    .tc-container {
        height: 60vh;
        overflow-y: scroll;
    }

    .term-verbiage {
        line-height: 24px;
        font-size: 16px;
    }

    .check-box {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-input--is-disabled:not(.v-input--is-readonly) .theme--light.v-label {
        color: $grey-darken-2 !important;
    }

    .theme--light.v-input--is-disabled {
        opacity: 30% !important;
    }

    .submit-button {
        height: fit-content !important;
        min-width: 160px;
        white-space: normal;
        display: block;

        @media #{map-get($display-breakpoints, "sm-and-up")} {
            display: inline-flex;
            white-space: nowrap;
            width: auto;
            height: auto;
        }
    }
</style>
